module.exports = __webpack_public_path__ + "img/028.f9b3726e.jpg";